module.exports = __webpack_public_path__ + "static/img/bar.8af02d1d.png";